import config from '@iotv/config';
import { NodeEdgeMapper } from '@iotv/datamodel';
import { getThingAlerts, getThingImageUrl, getThingShadowStates, subscribeToThingAlertTopic, subscribeToThingTopic, subscribeToUserChannel, } from '../daoFunctions/daoFunctions';
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * @deprecated This is no longer necessary, and it's previous usage in the authentication flow (with a zombie user, rather than full object) led to datastore corruption of the user object
 *
 * @function userThingsQuery Gets the latest ThingShadowState and Alerts ( which are actually deprecated ) for each of the users DeviceEnabaledTypes via AppState's normalized data, and sets up MQTT topic subscriptions to each
 * @param user
 * @param normalizedData
 * @param things
 * @returns
 */
const userThingsQuery = async function (user, things) {
    const nodeEdgeMapper = new NodeEdgeMapper();
    if (user && !process.env.REACT_APP_LESS) {
        if (things.length > 0) {
            debug && console.log('User things', things);
            const queryPromises = [...things.map((thing) => getThingImageUrl(thing))];
            if (config.app.appCode !== 'i001x') {
                const tssQueries = [getThingShadowStates(things, nodeEdgeMapper), getThingAlerts(things, nodeEdgeMapper)];
                tssQueries.forEach((query) => queryPromises.push(query));
            }
            await Promise.all(queryPromises);
            const pubSubPromises = [
                ...things.map((thing) => {
                    debug && console.log('subscribing to thing topic', thing.id);
                    return subscribeToThingTopic(thing, user);
                }),
                ...things.map((thing) => {
                    return subscribeToThingAlertTopic(thing, user);
                }),
                //getGeofences(user, normalizedData),
                subscribeToUserChannel(user),
            ];
            await Promise.all(pubSubPromises);
        }
    }
    else {
    }
    debug && console.log('User query returning', nodeEdgeMapper);
    return nodeEdgeMapper;
};
export { userThingsQuery };
